export default {
  set(state, { data }) {
    state.boxes = data;
  },
  show(state, { data }) {
    state.box = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}